import script from "./CartBodyPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CartBodyPanel.vue?vue&type=script&setup=true&lang=js"

import "./CartBodyPanel.vue?vue&type=style&index=0&id=67dd1734&lang=scss"

const __exports__ = script;

export default __exports__